// From the End User Access prototype, re-read 2026-10-19. More copy revisions are coming (SME-1119).
export const copy = {
  screen: {
    title: 'End User Access',
    lockedHint: 'Publish a content module to set up End User Access.',
    lockedLink: 'Go to Content Library →',
  },
  manage: {
    title: 'Manage end user channel access',
    description: 'Control how users try, register for, and access your channel.',
  },
  saveHints: {
    paymentUrl: 'Add a trial payment page URL to save ↓',
    guestPaymentUrl: 'Add a guest payment page URL to save ↓',
  },
  trials: {
    title: 'Enable trials',
    description:
      'Allow new users to receive a free trial, whether they register themselves or are invited by a Program Manager. When their trial ends, they will be directed to your selected payment page to subscribe.',
    ownPage: 'Use your own payment page',
    ownPageDescription: 'Send users to your own payment page to complete their subscription when the trial ends.',
    sidekickCheckout: 'Use Sidekick checkout',
    sidekickCheckoutDescription: 'Send users to Sidekick checkout to complete their subscription.',
    urlPlaceholder: 'https://yourpaymentpage.com/subscribe',
    urlLabel: 'Payment page URL',
    invalidUrl: 'Please enter a valid URL.',
  },
  registration: {
    title: 'Channel registration',
    description: 'Configure how users can get an account and access your channel.',
  },
  manualInvites: {
    title: 'Manual invites',
    description: 'Choose the default access type for users invited manually from the People page.',
  },
  selfReg: {
    title: 'Allow self-registration',
    description:
      'Users can create their own account using the channel registration link. Program Managers can also invite users directly.',
    accessTitle: 'Self-registration access type',
    accessDescription: 'Choose what type of access new users receive when they register through this link.',
    shareLink: 'Share this link with users so they can register directly for your channel:',
    paidUnavailable: 'Not available while trials are on. Self-registered users start as trial users.',
  },
  accessTypes: {
    channel: {
      label: 'Paid by your channel',
      invite: 'Your channel pays for invited users’ access.',
      selfReg: 'Your channel pays for self-registered users’ access.',
    },
    trial: {
      label: 'Free trial',
      invite:
        'Invited users receive one month of free access to your channel, beginning when they first log in. After the trial ends, they will be prompted to subscribe.',
      selfReg: 'Users receive one month of free access before being prompted to subscribe.',
    },
    paying: {
      label: 'Paid subscription required',
      invite: 'Invited users must purchase a subscription to access your channel.',
      selfReg: 'Users must purchase a subscription to access your channel.',
    },
  },
  guest: {
    title: 'Guest user access',
    description: (limit: number) =>
      `Allow guests to explore your channel without signing in. Guests can browse unlocked content and interact with a Sidekick up to ${limit} times before being prompted to register.`,
    destinationTitle: 'When guests reach their limit',
    destinationDescription: 'Choose where guests are sent when they reach their interaction limit.',
    trialPage: 'Use your trial payment page',
    trialPageDescription: 'Send guests to the same page as users whose trial has ended.',
    trialPageUnavailable: 'Available while trials are on.',
    otherPage: 'Use a different payment page',
    otherPageDescription: 'Send guests to a separate page to subscribe.',
    urlLabel: 'Guest payment page URL',
    registerForm: 'Use your self-registration form',
    registerFormDescription: (asTrial: boolean) =>
      `Send guests to your channel’s registration form to sign up as a ${asTrial ? 'trial user' : 'user'}.`,
    registerFormUnavailable: 'Available while Allow self-registration is on.',
  },
  discoverable: {
    title: 'Discoverable',
    description:
      'Make your channel visible to people browsing the Sidekick Platform. At least one content module must be published before your channel can be discovered.',
    needsSelfReg: 'Turn on Allow self-registration first, so people who find your channel can join it.',
    blockedTitle: 'Publish a content module first',
    blockedBody:
      'Your channel doesn’t have any published content modules yet, so there’s nothing for people to discover. Publish at least one module, then make the channel discoverable.',
    blockedLink: 'Go to Content Library →',
  },
  webSetup: {
    title: 'Web Setup',
    description: 'Make it easy for users to access your Sidekick channel from your website.',
    linkTitle: '1. Add the channel link to your website',
    linkBody:
      'Add this link to a button, menu item, or other location on your website to direct users to your Sidekick channel. If guest access is enabled, users will be directed to your Content Library. Otherwise, they’ll be directed to the login screen.',
    buttonTitle: '2. Create your website button',
    buttonBefore: 'Visit the',
    buttonLink: 'Sidekick Implementation Kit',
    buttonAfter: 'for button designs, downloadable assets, and step-by-step setup instructions.',
  },
  comingSoon: 'Coming soon',
}
